import sizes from "constants/sizes";
import {getDateString, makeJustDay} from "./dateFunctions"
class DateHelper {
  constructor(date = new Date()) {
    if (typeof date === "string") {
      date = this.constructor.parseDate(date);
    }
    this.date = this.constructor.makeJustDay(date);
    this.month = this.date.getMonth();
    this.year = this.date.getFullYear();
    this.startYear = this.year;
    this.dateNum = this.date.getDate();
    this.dayNum = this.date.getDay();
    this.someday = this.constructor.someday();
    this.somedayDateString = "5000-01-01";
    this.monthData = [
      { shortName: "Jan", name: "January", length: 31 },
      { shortName: "Feb", name: "February", length: 28 },
      { shortName: "Mar", name: "March", length: 31 },
      { shortName: "Apr", name: "April", length: 30 },
      { shortName: "May", name: "May", length: 31 },
      { shortName: "Jun", name: "June", length: 30 },
      { shortName: "Jul", name: "July", length: 31 },
      { shortName: "Aug", name: "August", length: 31 },
      { shortName: "Sep", name: "September", length: 30 },
      { shortName: "Oct", name: "October", length: 31 },
      { shortName: "Nov", name: "November", length: 30 },
      { shortName: "Dec", name: "December", length: 31 },
    ];
    this.currentMonthName = this.monthData[this.month]["name"];
    this.dayNames = [
      { short: "Sun", long: "Sunday" },
      { short: "Mon", long: "Monday" },
      { short: "Tue", long: "Tuesday" },
      { short: "Wed", long: "Wednesday" },
      { short: "Thu", long: "Thursday" },
      { short: "Fri", long: "Friday" },
      { short: "Sat", long: "Saturday" },
    ];
  }

  static dateString(date) {
    return getDateString(date)
  }

  static parseDate(string) {
    if (string.getTime) {
      return string;
    }
    if (!string) {
      return null;
    }
    const parts = string.split("-");
    return new Date(parts[0], parts[1] - 1, parts[2].slice(0, 2));
  }

  static makeJustDay(date) {
    return makeJustDay(date)
  }

  static absDayDiff(date1, date2) {
    return Math.abs((date2.getTime() - date1.getTime()) / (1000 * 3600 * 24));
  }

  static toMinutes(timeString) {
    const ar = timeString.split(":");
    return (
      (ar[0] === "12" ? 0 : parseInt(ar[0]) * 60) +
      parseInt(ar[1].slice(0, 2)) +
      (ar[1][2] == "p" ? 720 : 0)
    );
  }

  static someday() {
    return new Date(5000, 0, 1);
  }

  static interval(date, num, timeUnit) {
    switch (timeUnit) {
      case "days":
        return new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() + num
        );
      case "weeks":
        return new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() + 7 * num
        );
      case "months":
        return new Date(
          date.getFullYear(),
          date.getMonth() + num,
          date.getDate()
        );
      case "years":
        return new Date(
          date.getFullYear() + num,
          date.getMonth(),
          date.getDate()
        );
      default:
        throw Error("invalid time units");
    }
  }

  static dayRange(date1, date2) {
    let result = [];
    let currentDate = new Date(date1.getTime());
    result.push(currentDate);
    while (currentDate.getTime() < date2.getTime()) {
      currentDate = new Date(currentDate.getTime());
      currentDate.setDate(currentDate.getDate() + 1);
      result.push(currentDate);
    }
    return result;
  }

  todayDetails(date) {
    return { day_name: "Today", day: this.getDateString(), type: "day_name" };
  }

  parseDate(date) {
    return DateHelper.parseDate(date);
  }

  getMonthBox(date) {
    const month = date.getMonth();
    const monthLength = this.monthData[month].length;
    const daysLeft = monthLength - date.getDate();
    const numOverflowDays = (daysLeft + date.getDay() + 1) % 7;
    if (daysLeft < numOverflowDays) {
      return (month + 1) % 12;
    }
    return month;
  }

  getMonthName(i) {
    return this.monthData[i % 12]["name"];
  }

  shortMonthName(i) {
    return this.monthData[i % 12]["shortName"];
  }

  getMonthLength(i) {
    return this.monthData[i % 12]["length"];
  }

  yearAfterMonths(numMonthsAway) {
    return this.year + Math.floor((this.month + numMonthsAway) / 12);
  }

  getDayNameLong(date, options) {
    if (date.getFullYear() === 5000) return "Someday";
    options = options ? options : {};
    const dayNames = this.dayNames[date.getDay()];
    const dayOfWeekName =
      options.wordNames === "short" ? dayNames.short + "," : dayNames.long;
    const dayName = dayOfWeekName + " " + date.getDate();
    let month = this.monthData[date.getMonth()].name;
    if (options.wordNames === "short") {
      month = month.slice(0, 3);
    }
    const isSameYear = date.getFullYear() === this.year;
    const year = isSameYear ? "" : ", " + date.getFullYear();
    return dayName + " " + month + year;
  }

  makeDateString(date) {
    return this.constructor.dateString(date);
  }

  getDateString() {
    return this.constructor.dateString(this.date);
  }

  tomorrowDateString() {
    return this.constructor.dateString(
      this.constructor.interval(this.date, 1, "days")
    );
  }

  generateMonthsThrough({ endYear, startDate, endDate }) {
    if (endYear !== undefined) {
      const yearDiff = endYear - this.year;
      return this.generateMonths(yearDiff * 12);
    } else if (startDate) {
      const _endDate = endDate || this.date;
      return this.generateMonths(null, { startDate, endDate: _endDate });
    }
  }

  interval(num, timeUnit) {
    switch (timeUnit) {
      case "weeks":
        return new Date(this.year, this.month, this.dateNum + 7 * num);
      case "months":
        return new Date(this.year, this.month + num, this.dateNum);
      case "years":
        return new Date(this.year + num, this.month, this.dateNum);
      default:
        throw Error("invalid time units");
    }
  }

  monthLength(monthNum, year) {
    if (
      monthNum === 1 &&
      year % 4 === 0 &&
      (year % 100 !== 0 || year % 400 === 0)
    ) {
      return 29;
    } else {
      return this.monthData[monthNum].length;
    }
  }

  daysBetween(date1, date2) {
    return (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24);
  }

  monthsBetween(startDate, endDate) {
    return Math.abs(
      (endDate.getYear() - startDate.getYear()) * 12 +
        endDate.getMonth() -
        startDate.getMonth()
    );
  }

  heightOnCalendar(date, options = {}) {
    const { beforeToday, isCondensed } = options;
    const startDate = beforeToday ? this.startDate : this.date;
    const dayRowsHeight =
      Math.floor((this.daysBetween(startDate, date) + this.dayNum) / 7) *
      sizes.calDayHeight;
    const monthHeadersHeight = isCondensed
      ? 0
      : this.monthBoxesFromNow(date, startDate) * sizes.monthHeaderHeight;
    return dayRowsHeight + monthHeadersHeight;
  }

  monthBoxesFromNow(date, startDate = this.date) {
    const monthBox = this.getMonthBox(date);
    let yearMonths = (date.getFullYear() - startDate.getFullYear()) * 12;
    if (date.getMonth() > monthBox) {
      yearMonths += 12;
    }
    return monthBox - this.getMonthBox(startDate) + yearMonths;
  }

  generateMonths(numMonths, options = {}) {
    const startDate = options.startDate || this.date;
    const { endDate } = options;
    let lastDay;
    if (startDate && endDate) {
      numMonths = this.monthsBetween(startDate, endDate) + 1;
      lastDay = endDate.getDate();
    }
    let result = [];
    let currentDateNum = startDate.getDate();
    let currentDayOfWeek = startDate.getDay();
    let year = startDate.getFullYear();
    let startMonth = startDate.getMonth();
    let overflowDays = [];
    for (let i = 0; i < numMonths; i++) {
      let month = {};
      month.monthNum = i + startMonth;
      month.year = year + Math.floor(month.monthNum / 12);

      let monthLength = this.monthLength(month.monthNum % 12, month.year);

      month.name = this.monthData[month.monthNum % 12].name;

      let overflow = {};
      if (overflowDays.length > 0) {
        overflow.monthNum = month.monthNum === 0 ? 11 : month.monthNum - 1;
        overflow.days = overflowDays;
        currentDayOfWeek += overflowDays.length;
        overflowDays = [];
        overflow.year = month.monthNum % 12 === 0 ? month.year - 1 : month.year;
      }
      month.overflow = overflow;

      // adding weeks
      let days = [];
      let numWeeks = 0;
      while (currentDateNum <= monthLength) {
        if (
          currentDateNum + (6 - currentDayOfWeek) > monthLength &&
          i !== numMonths - 1
        ) {
          for (
            currentDateNum;
            currentDateNum <= monthLength;
            currentDateNum++
          ) {
            overflowDays.push(currentDateNum);
          }
          break;
        }
        for (currentDayOfWeek; currentDayOfWeek < 7; currentDayOfWeek++) {
          // adding days
          days.push(currentDateNum);
          if (lastDay != undefined) {
            if (i === numMonths - 1 && lastDay === currentDateNum) {
              currentDateNum = 100; // just so we finish loop but don't iterate again
              break;
            }
          }
          currentDateNum++;
        }
        numWeeks++;
        currentDayOfWeek = 0;
      }
      currentDateNum = 1;

      if (days.length === 0) {
        continue;
      }
      month.numWeeks = numWeeks;
      month.days = days;

      result.push(month);
    }
    return result;
  }
}

export { DateHelper };
